import React, {useEffect, useState} from 'react';
import Select from 'react-select';
import {
  useLazyRegionsListQuery,
  useSetUserRegionMutation,
} from '../../../store/builder/inspections.api';
import CustomLoader from '../../CustomLoader/CustomLoader';
import {toast} from 'react-toastify';

const UpdateRegion = ({setSetRegion, currentUser, getUsers}) => {
  const [chosenRegion, setChosenRegion] = useState({});
  const [getRegions, {data: regionsData}] = useLazyRegionsListQuery();

  const [updateUserRole, {isLoading: setRegionIsLoading}] =
    useSetUserRegionMutation();

  useEffect(() => {
    const matchedRegion = regionsData?.find(
      reg => currentUser?.region_id === reg?.id,
    );

    if (currentUser && matchedRegion) {
      setChosenRegion({
        value: matchedRegion?.id,
        label: matchedRegion?.name,
      });
    }
  }, [currentUser, regionsData]);

  useEffect(() => {
    if (currentUser?.corporate_id) {
      getRegions({
        corporate_id: currentUser?.corporate_id,
      });
    }
  }, [currentUser]);
  const handleCancel = () => {
    setSetRegion(false);
  };

  const handleConfirm = () => {
    const body = {
      region_id: chosenRegion.value,
    };
    updateUserRole({
      id: currentUser?.id,
      body,
    })
      .unwrap()
      .then(data => {
        setSetRegion(false);
        toast.success(data?.message);
        getUsers();
      })
      .catch(error => {
        toast.error(error?.data?.message || 'Failed to update region');
      });
  };

  return (
    <form className='modal'>
      <div className='modal__content'>
        <div className='modal__content-head'>
          <p>Set region</p>
          <img
            className='modal__content-exit'
            src='/assets/icons/close.svg'
            alt='close'
            onClick={handleCancel}
          />
        </div>
        <div className='modal__content-body user' style={{paddingTop: 0}}>
          <div className='customSelect'>
            <span className='customSelect__label'>Region</span>
            <Select
              options={regionsData?.map(reg => ({
                value: reg.id,
                label: reg.name,
              }))}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                  borderRadius: 8,
                  height: 42,
                  backgroundColor: '#F4F5F6',
                  marginTop: 8,
                }),
                menuPortal: base => ({...base, zIndex: 9999}),
              }}
              value={chosenRegion}
              onChange={e => setChosenRegion(e)}
              menuPosition={'absolute'}
              menuPortalTarget={document.body}
            />
          </div>
        </div>

        <div className='modal__content-bottom'>
          <button type='button' className='close' onClick={handleCancel}>
            Cancel
          </button>
          <button
            type='button'
            className='save'
            onClick={handleConfirm}
            disabled={!chosenRegion?.value || setRegionIsLoading}
          >
            <div>
              {setRegionIsLoading ? <CustomLoader width={10} /> : 'Update'}
            </div>
          </button>
        </div>
      </div>
      <div className='modal__bg'></div>
    </form>
  );
};

export default UpdateRegion;
